module.exports = __webpack_public_path__ + "img/suit-heart.94191478.svg";